
import { useInjectLandingPage } from '@/hooks/use_landing_page';

export function useContentGroup(groupName: string) {
  const landingPage = useInjectLandingPage();
  return landingPage.groups.find(item => item.uniqueKey === groupName);
}
